import { defineComponent, PropType } from "vue";

import { COMPONENT_NAME, SVG } from "./attributes";

import { AdminUsersTableRow } from "./row";

import { PAGE_SIZE, SvgAttribute } from "@/shared/constants/constants";
import { AdminUsersResponse } from "@/shared/repository/modules/admin/users/repo";
import {
  AdminUsersTableHeaders,
  AdminUsersTableHeader,
} from "@/data/admin/users/table";
import { Search, Sort } from "@/shared/constants/interfaces";
import { SearchStatus, SearchType } from "@/shared/constants/enums";

export default defineComponent({
  name: COMPONENT_NAME,
  components: {
    AdminUsersTableRow,
  },
  props: {
    search: {
      type: <PropType<Search>>Object,
      required: true,
    },
    sort: {
      type: <PropType<Sort>>Object,
      required: true,
    },
    isStatus: {
      type: Boolean,
      default: false,
    },
    isBalance: {
      type: Boolean,
      default: false,
    },
  },
  emits: {
    "update:isStatus": null,
    "update:isBalance": null,
  },
  data() {
    return {
      usersRepo: this.$projectServices.usersRepo,
    };
  },
  computed: {
    displayedIcons(): SvgAttribute {
      return SVG;
    },

    displayedColumns(): AdminUsersTableHeader[] {
      return AdminUsersTableHeaders;
    },

    displayedUsers(): AdminUsersResponse[] {
      const { value, type, status } = this.search;
      let users = this.usersRepo.users;

      if (status !== SearchStatus.all) {
        if (status === SearchStatus.none) {
          users = users.filter(
            (user) => user.kyb_staus == null && user.kyc_status == null
          );
        } else {
          users = users.filter(
            (user) => user.kyb_staus === status || user.kyc_status === status
          );
        }
      }

      users = users.filter((user) => {
        if (value) {
          switch (type) {
            case SearchType.all:
              return `${user.id} ${user.email} ${user.applicant_name ?? ""} ${
                user.applicant_surname ?? ""
              }`
                .toLowerCase()
                .includes(value.toLowerCase());
            case SearchType.id:
              return user.id
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase());
            case SearchType.email:
              return user.email
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase());
            case SearchType.fio:
              return `${user.applicant_name ?? ""} ${user.applicant_surname}`
                .toLowerCase()
                .includes(value.toLowerCase());
            default:
              return user;
          }
        }

        return user;
      });
      return users.slice(
        (this.sort.page - 1) * PAGE_SIZE,
        this.sort.page * PAGE_SIZE
      );
    },
  },
  methods: {
    handleChangeIsStatus(isStatus: boolean): void {
      this.$emit("update:isStatus", isStatus);
    },

    handleChangeIsBalance(isBalance: boolean): void {
      this.$emit("update:isBalance", isBalance);
    },
  },
});
